/* DocumentState constants */

export const ON_AGREEMENT = '2340461775000';
export const ON_AGREED = '2708800026000';
export const ON_ARCHIVED = '6145732000';
export const ON_CREATED = '4412156070000';
export const ON_REJECTED = '2708800028000';

